<template>
  <svg
    t="1736862609785"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6042"
    width="200"
    height="200"
  >
    <path
      d="M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z m0-85.333c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512 276.352 938.667 512 938.667z m-42.667-469.334a42.667 42.667 0 0 1 85.334 0V768a42.667 42.667 0 0 1-85.334 0V469.333z m38.4-136.533a59.733 59.733 0 1 1 0-119.467 59.733 59.733 0 0 1 0 119.467z"
      p-id="6043"
      fill="#a7a9af"
    ></path>
  </svg>
</template>
